export default "__VITE_ASSET__C0C_mMu5__"